export const mapParentRow = (item, { isOrigin = false } = {}) => ({
  father_name: item?.father_name,
  mother_name: item?.mother_name,
  children_count: item?.children_count || 0,
  last_visit_date: item?.last_visit_date,
  is_registered_on_app: item?.is_registered_on_app,
  duplicate_data_count: item?.duplicate_data_count,
  is_origin: isOrigin,
  id: item?.id,
});

// Dengan group_duplicates=1, `parents` berisi klaster { origin, duplicates }:
// - tanpa limit: array klaster
// - dengan limit: paginator Laravel, `data` berisi klaster (total = jumlah klaster)
export const normalizeDuplicateClusters = (parents) => {
  const isPaginator = !!parents && !Array.isArray(parents) && !!parents.data;
  const rawClusters = (isPaginator ? parents.data : parents) || [];

  const clusters = rawClusters
    .filter((cluster) => cluster?.origin)
    .map((cluster) => ({
      key: cluster.origin.id,
      origin: mapParentRow(cluster.origin, { isOrigin: true }),
      duplicates: (cluster.duplicates || []).map((item) => mapParentRow(item)),
    }));

  return {
    clusters,
    currentPage: (isPaginator && parents.current_page) || 1,
    lastPage: (isPaginator && parents.last_page) || 1,
    total: isPaginator ? parents.total || 0 : clusters.length,
  };
};
